import React from 'react';
import ScreeningRequiredBulletPoint from './ScreeningRequiredBulletPoint';
import CustomRequirementsBulletPoint from './CustomRequirementsBulletPoint';
import MultipleRequirementsBulletPoint from './MultipleRequirementsBulletPoint';
import GetStartedBulletPoint from './GetStartedBulletPoint';

type Props = {
  requirements?: any[];
  testType: string;
};

const Requirements = (props: Props) => {
  const { requirements, testType } = props;

  return (
    <>
      <ScreeningRequiredBulletPoint requirements={requirements} />

      <CustomRequirementsBulletPoint requirements={requirements} />

      <MultipleRequirementsBulletPoint requirements={requirements} />

      <GetStartedBulletPoint requirements={requirements} testType={testType} />
    </>
  );
};

export default Requirements;
